import {
  ActionType,
  ProColumns,
} from "@ant-design/pro-components";
import { debounce } from "@mui/material";
import {
  Tooltip as AntdTooltip,
  Button,
  Checkbox,
  DatePicker,
  Divider,
  Form,
  Input,
  Radio,
  RadioChangeEvent,
  Select,
  Space,
} from "antd";
import CustomSelect from "base/ui/components/CustomSelect";
import CustomProTable from "base/ui/components/CustomTable";
import { observer } from "mobx-react-lite";
import moment from "moment";
import { useCallback, useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { AiOutlineDownload } from "react-icons/ai";
import {
  DropdownRouting,
  ListDate,
  ListStatusProduct,
} from "services/commonDate_services";
import { BC07, ListKeynValue } from "services/report_services";
import * as rootStore from "stores/root_store";
import { PAGE_SIZE_DEFAULT } from "utils/constants";
import { formatNumber } from "utils/formatHelper";
import SaveReportForm from "../reportComponents/reportForm";
import TemplateReportModal from "base/ui/components/Modal/TemplateReportModal";
import Wrapper from "base/ui/components/Wrapper";
import SearchCollapse from "../reportComponents/searchCollapse";
import { useResizableColumns } from "utils/reportHelper";
import dayjs from "dayjs";
import { cloneDeep } from "lodash";

import {
  commonDateStore,
  commonDatePresenter,
} from "stores/root_store";

type DataSearch = {
  paging: {
    pageSize: number;
    pageIndex: number;
    orderBy: string;
    orderByDesc: string;
  };
  lsx: string[];
  // thành phẩm bán thành phẩm
  tpbtp: string;
  trangThaiMES: string[];
  tgHoanThanhLSXTu?: string;
  tgHoanThanhLSXDen?: string;
  tgPhatLenhTu?: string;
  tgPhatLenhDen?: string;
  ngaySanXuatTu?: string;
  ngaySanXuatDen?: string;
  listStepCode: string[];
  // TH : Tổng hợp , CT : chi tiết
  type: string;
  // lệnh sản xuất vệ sinh
  lsxVeSinh: boolean | null;
  nhanViens: string[];
  // Máy / chuyền thực hiện
  equipmentCode: string[];
  // khách hàng
  // khachHang?: string[];
  khachHang?: string;
  workOrderRoutingStatus?: string
};

export function createCompletionRate() {
  return observer(() => {
    //=======================================================================
    //======================================================================= REGISTER VARIALBE ZONE
    //=======================================================================
    //loading page when reload
    const [isLoading, setIsLoading] = useState(false);
    //======================================================================= search zone
    // load equipment name
    const [listEquip, setListEquip] = useState<ListKeynValue[]>([]);
    // danh sach LSX
    const [listLSX, setListLSX] = useState<ListKeynValue[]>([]);
    // Danh sach công đoạn
    // data dropdown routing
    const [listRouting, setListRouting] = useState<DropdownRouting[]>([]);
    // list status danh sach trang thai
    const [listStatus, setListStatus] = useState<ListKeynValue[]>([]);
    // danh sach trang thai công đoạn
    const [listWORoutingStatus, setListWORoutingStatus] = useState<ListKeynValue[]>([]);
    // Danh sách nhân viên
    const [listEmployee, setListEmployee] = useState<ListStatusProduct[]>([]);
    // Danh sách khách hàng
    // Form validation-----------------------------------
    const [dataSearch, setDataSearch] = useState<DataSearch>({
      paging: {
        pageSize: PAGE_SIZE_DEFAULT,
        pageIndex: 1,
        orderBy: "",
        orderByDesc: "",
      },
      lsx: [] as string[],
      tpbtp: "",
      trangThaiMES: ["CLOSED"],
      tgHoanThanhLSXTu: undefined,
      tgHoanThanhLSXDen: undefined,
      tgPhatLenhTu: undefined,
      tgPhatLenhDen: undefined,
      ngaySanXuatTu: undefined,
      ngaySanXuatDen: undefined,
      listStepCode: [],
      // TH : Tổng hợp , CT : chi tiết
      type: "TH",
      lsxVeSinh: false,
      nhanViens: [],
      equipmentCode: [],
      khachHang: undefined,
    });

    const [pickedDate, setPickedDate] = useState({
      pickedDateNGH: "ThisMonth",
      pickedDateLSX: "",
      pickedDateTGSX: "",
    });

    const { register, handleSubmit } = useForm<String>();
    // lay danh sach date tu API
    const [commonDate, setCommonDate] = useState<ListDate[]>([]);
    // autocomplete tp/btp
    const [dropdownProduct, setDropdownProduct] = useState<ListStatusProduct[]>(
      []
    );
    // Kiểm tra call xong  api lấy ngày picked date
    const [isReady, setIsReady] = useState(false);

    const [dataTable, setDataTable] = useState<BC07[]>([]);

    // chọn tất cả routing
    const [selectAllRouting, setSelectAllRouting] = useState(false);

    //=======================================================================
    //======================================================================= GET LISTS
    //=======================================================================
    // GET LISTS LSX
    const getWoCode = async (keyword = "") => {
      if (keyword && keyword.length >= 3) {
        await rootStore.reportPresenter.getDropdownWo(
          rootStore.reportStore,
          keyword
        );
        if (rootStore.reportStore.listKeynValue.isSuccess) {
          setListLSX(rootStore.reportStore.listKeynValue.data);
        }
      } else {
        setListLSX([]);
      }
    };
    // debounce lsx
    const debounceLSX = useCallback(debounce(getWoCode, 300), []);

    // lấy danh sách common date
    const getDateCommon = async () => {
      await commonDatePresenter.getListCommonDate(
        commonDateStore
      );
      setCommonDate(rootStore.commonDateStore.listDate.data);
    };

    // lấy ngày từ commonDate
    const getDateByKey = async (
      key: string,
      type: "delivery" | "create" | "SX"
    ) => {
      await rootStore.commonDatePresenter.getDataByCommonDate(
        rootStore.commonDateStore,
        key
      );
      if (rootStore.commonDateStore.commonDate) {
        switch (type) {
          // lấy ngày phát lệnh
          case "create": {
            setDataSearch({
              ...dataSearch,
              tgPhatLenhTu:
                rootStore.commonDateStore.commonDate.fromDate !== ""
                  ? rootStore.commonDateStore.commonDate.fromDate
                  : undefined,
              tgPhatLenhDen:
                rootStore.commonDateStore.commonDate.toDate !== ""
                  ? rootStore.commonDateStore.commonDate.toDate
                  : undefined,
            });
            break;
          }
          // ngày hoàn thành lệnh sản xuất
          case "delivery": {
            setDataSearch({
              ...dataSearch,
              tgHoanThanhLSXTu:
                rootStore.commonDateStore.commonDate.fromDate !== ""
                  ? rootStore.commonDateStore.commonDate.fromDate
                  : undefined,
              tgHoanThanhLSXDen:
                rootStore.commonDateStore.commonDate.toDate !== ""
                  ? rootStore.commonDateStore.commonDate.toDate
                  : undefined,
            });
            break;
          }
          case "SX": {
            setDataSearch({
              ...dataSearch,
              ngaySanXuatTu:
                rootStore.commonDateStore.commonDate.fromDate !== ""
                  ? rootStore.commonDateStore.commonDate.fromDate
                  : undefined,
              ngaySanXuatDen:
                rootStore.commonDateStore.commonDate.toDate !== ""
                  ? rootStore.commonDateStore.commonDate.toDate
                  : undefined,
            });
            break;
          }
        }
      }
    };
    // Trạng thái MES
    const getListStatus = async () => {
      await rootStore.commonDatePresenter.getDropdownByKeyword(
        rootStore.commonDateStore,
        "WorkOrderStatusMes"
      );
      let array: ListKeynValue[] = [];
      rootStore.commonDateStore.dropdownByKey.map((it) => {
        if (it.key !== "PLANNED") array.push(it);
      });
      setListStatus(array);
    };
    // Trạng thái công đoạn
    const getListWORountingStatus = async () => {
      await rootStore.commonDatePresenter.getDropdownByKeyword(
        rootStore.commonDateStore,
        "WorkOrderRoutingStatus"
      );

      setListWORoutingStatus(rootStore.commonDateStore.dropdownByKey);
    };
    // Lấy dropdown công đoạn
    const getDataDropdownRouting = async (dataSearch = "") => {
      await rootStore.commonDatePresenter.getDropdownRouting(
        rootStore.commonDateStore,
        dataSearch
      );
      if (rootStore.commonDateStore.dropdownRouting.isSuccess) {
        setListRouting(rootStore.commonDateStore.dropdownRouting.data);
      }
    };

    const debounceListRouting = useCallback(debounce(getDataDropdownRouting, 300), [])

    // lấy danh sách nhân viên
    const getListEmployees = async (keyword = "") => {
      await rootStore.commonDatePresenter.getDropdownSaleEmployee(
        rootStore.commonDateStore,
        keyword,
        []
      );
      if (rootStore.commonDateStore.listStatusProductResponse.isSuccess) {
        setListEmployee(
          rootStore.commonDateStore.listStatusProductResponse.data
        );
      }
    };

    const debounceEmployees = useCallback(debounce(getListEmployees, 500), []);



    // get data table
    const getDataAPI = async (values: DataSearch) => {
      setDataTable([]);
      await rootStore.reportPresenter.getDataBC07(rootStore.reportStore, {
        ...values,
        ngaySanXuatTu: values.type === "CT" ? values.ngaySanXuatTu : undefined,
        ngaySanXuatDen: values.type === "CT" ? values.ngaySanXuatDen : undefined,
        nhanViens: values.type === "CT" ? values.nhanViens : undefined,
      });
      if (rootStore.reportStore.BC07Response.isSuccess) {
        const data = rootStore.reportStore.BC07Response.data.map((item) => ({
          ...item,
          key: `${item.stt}`,
          children: item.routings.map((routing, index) => ({
            ...routing,
            chiTietBaoCao: {
              ...routing.chiTietBaoCao,
              ...(routing.chiTietBaoCao.danhSachMayMoc
                ? routing.chiTietBaoCao.danhSachMayMoc.reduce(
                  (acc, item, i) => ({
                    ...acc,
                    [`danhSachMayMoc${i + 1}`]: item,
                  }),
                  {}
                )
                : {}),
            },

            key: `${item.stt}.${index + 1}`,
          })),
        }));

        const temp = cloneDeep(columns);

        if (columns[columns.length - 1].key === "mayMoc") temp.pop();
        if (dataSearch.type === "TH") {
          temp.map((ct) => {
            if (ct.hideInTable === false) {
              ct.hideInTable = true;
              ct.hideInSetting = true;
              return ct;
            }
            return ct;
          });

          setColumn(temp);
        } else if (dataSearch.type === "CT") {
          temp.map((ct) => {
            if (ct.hideInTable === true) {
              ct.hideInTable = false;
              ct.hideInSetting = false;
              return ct;
            }
            return ct;
          });
          // setColumn(temp);
          // let longestArrIndex: {arrLength: number; dataIndex: number; rountingIndex: number};
          const arrMaxLength = rootStore.reportStore.BC07Response.data.reduce(
            (maxLength, taskObj) => {
              return Math.max(
                maxLength,
                ...taskObj.routings.map((resObj) =>
                  resObj.chiTietBaoCao.danhSachMayMoc
                    ? resObj.chiTietBaoCao.danhSachMayMoc.length
                    : 0
                )
              );
            },
            0
          );

          const last =
          // Máy móc / chuyền thực hiện
          {
            title: "Máy móc / chuyền thực hiện",
            dataIndex: "mayMoc",
            key: "mayMoc",
            width: 150,
            className: "whitespace-nowrap text-ellipsis overflow-hidden !py-1",
            hideInTable: false,
            hideInSetting: true,
            children: [
              ...Array.from({ length: arrMaxLength }, (_, i) => ({
                title: `Máy ${i + 1}`,
                // dataIndex: `arr${i + 1}`,
                key: `arr${i + 1}`,
                dataIndex: ["chiTietBaoCao", `danhSachMayMoc${i + 1}`],
                width: 150,
                className:
                  "whitespace-nowrap text-ellipsis overflow-hidden !py-1",
                render: (text: any, record: any) => {
                  return <AntdTooltip title={text}>{text}</AntdTooltip>;
                },
              })),
            ],
          };
          temp.push(last);
          setColumn(temp);
        }

        setDataTable(data);
        return data;
      }
      return [];
    };

    //=======================================================================
    //======================================================================= SEARCH ZONE
    //=======================================================================
    // lấy danh sách product
    // Lấy dropdown products
    const getDropdownProduct = async (key = "") => {
      if (key && key.length >= 3) {
        await rootStore.commonDatePresenter.getListDropdownProduct(
          rootStore.commonDateStore,
          key,
          "BC"
        );
        setDropdownProduct(rootStore.commonDateStore.listDropdownProduct);
      } else {
        setDropdownProduct([]);
      }
    };

    const debounceProduct = debounce(getDropdownProduct, 300);

    // handle search form
    const onSearch = async () => {
      setIsLoading(true);
      setDataSearch({
        ...dataSearch,
        paging: { ...dataSearch.paging, pageIndex: 1 },
      });
      await getDataAPI({
        ...dataSearch,
        paging: { ...dataSearch.paging, pageIndex: 1 },
      });
      setIsLoading(false);
      // const temp = cloneDeep(columns);

      // if (columns[columns.length - 1].key === "mayMoc") temp.pop();
      // if (dataSearch.type === "TH") {
      //   temp.map((ct) => {
      //     if (ct.hideInTable === false) {
      //       ct.hideInTable = true;
      //       ct.hideInSetting = true;
      //       return ct;
      //     }
      //     return ct;
      //   });

      //   setColumn(temp);
      // } else if (dataSearch.type === "CT") {
      //   temp.map((ct) => {
      //     if (ct.hideInTable === true) {
      //       ct.hideInTable = false;
      //       ct.hideInSetting = false;
      //       return ct;
      //     }
      //     return ct;
      //   });
      //   // setColumn(temp);
      //   // let longestArrIndex: {arrLength: number; dataIndex: number; rountingIndex: number};
      //   const arrMaxLength = rootStore.reportStore.BC07Response.data.reduce(
      //     (maxLength, taskObj) => {
      //       return Math.max(
      //         maxLength,
      //         ...taskObj.routings.map((resObj) =>
      //           resObj.chiTietBaoCao.danhSachMayMoc
      //             ? resObj.chiTietBaoCao.danhSachMayMoc.length
      //             : 0
      //         )
      //       );
      //     },
      //     0
      //   );

      //   const last =
      //   // Máy móc / chuyền thực hiện
      //   {
      //     title: "Máy móc / chuyền thực hiện",
      //     dataIndex: "mayMoc",
      //     key: "mayMoc",
      //     width: 150,
      //     className: "whitespace-nowrap text-ellipsis overflow-hidden !py-1",
      //     hideInTable: false,
      //     hideInSetting: true,
      //     children: [
      //       ...Array.from({ length: arrMaxLength }, (_, i) => ({
      //         title: `Máy ${i + 1}`,
      //         // dataIndex: `arr${i + 1}`,
      //         key: `arr${i + 1}`,
      //         dataIndex: ["chiTietBaoCao", `danhSachMayMoc${i + 1}`],
      //         width: 150,
      //         className:
      //           "whitespace-nowrap text-ellipsis overflow-hidden !py-1",
      //         render: (text: any, record: any) => {
      //           return <AntdTooltip title={text}>{text}</AntdTooltip>;
      //         },
      //       })),
      //     ],
      //   };
      //   temp.push(last);
      //   setColumn(temp);
      // }
    };



    //  FOR SEARCH : CẬP NHẬT THAY ĐỔI TRẠNG THÁI ===========================================================
    // hàm lấy value của các dropdown multiple
    const handleChangeSelectMul = (
      value: any,
      option: ListKeynValue | ListKeynValue[],
      idKey: string
    ) => {
      if (option && Array.isArray(option)) {
        setDataSearch({
          ...dataSearch,
          [idKey]: option.map((val) => {
            return val.key;
          }),
        });
      } else {
        setDataSearch({
          ...dataSearch,
          [idKey]: [],
        });
      }
    };
    const handleChangeListStep = (
      value: any,
      option: DropdownRouting | DropdownRouting[],
      idKey: string
    ) => {
      if (option && Array.isArray(option)) {
        setDataSearch({
          ...dataSearch,
          listStepCode: option.map((val) => {
            return val.stepCode;
          }),
        });
      } else {
        setDataSearch({
          ...dataSearch,
          listStepCode: [],
        });
      }
    };

    // Lấy danh sách máy/chuyền
    const getListEquipment = async (key?: string) => {
      // await rootStore.reportPresenter.getBC07ListEquipcard(rootStore.reportStore, data ? data : {});
      // if (rootStore.reportStore.listKeynValue.isSuccess) {
      //   setListEquip(rootStore.reportStore.listKeynValue.data);
      // }
      await rootStore.commonDatePresenter.getListDropdownEquipmentV2(
        rootStore.commonDateStore,
        key
      );
      if (rootStore.commonDateStore.dropdownEquipment.isSuccess) {
        setListEquip(rootStore.commonDateStore.dropdownEquipment.data);
      }
    };

    //debounce Lấy danh sách máy/chuyền
    const debounceListEquipcard = useCallback(
      debounce(getListEquipment, 300),
      []
    );

    // hàm lấy value của các dropdown (1 element)
    const handleChangeSelect = (
      value: any,
      option: ListKeynValue | ListKeynValue[],
      idKey: string
    ) => {
      if (option && !Array.isArray(option)) {
        // kiểm tra để gọi api lấy date dựa theo key
        if (idKey === "pickedDateLSX") {
          getDateByKey(option.key, "create");
          setPickedDate({ ...pickedDate, pickedDateLSX: option.key });
        } else if (idKey === "pickedDateNGH") {
          setPickedDate({ ...pickedDate, pickedDateNGH: option.key });
          getDateByKey(option.key, "delivery");
        } else if (idKey === "tgSanXuat") {
          setPickedDate({ ...pickedDate, pickedDateTGSX: option.key });
          getDateByKey(option.key, "SX");
        } else {
          setDataSearch({
            ...dataSearch,
            [idKey]: option.key,
          });
        }
      } else {
        // kiểm tra nếu không có key thì cho undefined
        if (idKey === "pickedDateLSX") {
          setPickedDate({ ...pickedDate, pickedDateLSX: "" });
          setDataSearch({
            ...dataSearch,
            tgPhatLenhTu: undefined,
            tgPhatLenhDen: undefined,
          });
        } else if (idKey === "pickedDateNGH") {
          setPickedDate({ ...pickedDate, pickedDateNGH: "" });
          setDataSearch({
            ...dataSearch,
            tgHoanThanhLSXTu: undefined,
            tgHoanThanhLSXDen: undefined,
          });
        } else if (idKey === "tgSanXuat") {
          setPickedDate({ ...pickedDate, pickedDateTGSX: "" });
          setDataSearch({
            ...dataSearch,
            ngaySanXuatTu: undefined,
            ngaySanXuatDen: undefined,
          });
        } else {
          setDataSearch({
            ...dataSearch,
            [idKey]: "",
          });
        }
      }
    };

    //=======================================================================
    //======================================================================= USEEFFECT ZONE
    //=======================================================================

    useEffect(() => {
      const fetchData = async () => {
        await getDateByKey(pickedDate.pickedDateNGH, "delivery");
        setIsReady(true);
        await getListStatus();
        await getDateCommon();
        // await getWoCode();
        await getDropdownProduct();
        await getDataDropdownRouting();
        await getListEmployees();
        await getListEquipment();
        getListWORountingStatus()

        getListCustomer();
      };
      fetchData();
    }, []);

    //========================================================================================================== //
    //-------------------------------------------TABLE COLUMN-------------------------------------------------//
    //========================================================================================================== //

    const [columns, setColumn] = useState<ProColumns<BC07>[]>([
      {
        title: "STT",
        dataIndex: "stt",
        width: 75,
        key: "stt",
        fixed: "left",
        className: "!rounded-none !py-1",
      },
      // Loaij lsx
      {
        title: "Loại LSX",
        dataIndex: "loaiLSX",
        key: "loaiLSX",
        className: "!py-1",
        fixed: "left",
        width: 100,
        sorter: true,
      },
      // LSX
      {
        title: "Lệnh SX",
        dataIndex: "lsx",
        key: "lsx",
        width: 150,
        className: "!py-1",
        fixed: "left",
        sorter: true,
      },
      // Mã TP/BTP
      {
        title: "Mã TP/BTP",
        dataIndex: "maTPBTP",
        key: "maTPBTP",
        width: 150,
        className: "!py-1",
        fixed: "left",
        sorter: true,
      },
      // Tên TP/BTP
      {
        title: "Tên TP/BTP",
        dataIndex: "tenTPBTP",
        key: "tenTPBTP",
        width: 200,
        className: "!py-1",
        render: (text, record) => {
          return <AntdTooltip title={text}>{text}</AntdTooltip>;
        },
      },
      // Khách hàng
      {
        title: "Khách hàng",
        dataIndex: "khachHang",
        key: "khachHang",
        width: 150,
        sorter: true,
        className: "!py-1",
        render: (text, record) => {
          return <AntdTooltip title={text}>{text}</AntdTooltip>;
        },
      },
      // Loại FSC
      {
        title: "Loại FSC",
        dataIndex: "loaiFSC",
        key: "loaiFSC",
        width: 75,
        className: "!py-1",
      },
      // Ngày ban hành LSX
      {
        title: "Ngày ban hành LSX",
        dataIndex: "ngayRaLSX",
        key: "ngayRaLSX",
        width: 200,
        sorter: true,
        className: "!py-1",
        render: (text, record) => {
          return {
            props: {
              style: {
                textAlign: "center",
              },
            },
            children: record.ngayRaLSX
              ? moment(record.ngayRaLSX).format("DD/MM/YYYY HH:mm:ss")
              : "",
          };
        },
      },
      // Ngày yêu cầu có hàng in
      {
        title: "Ngày yêu cầu có hàng in",
        dataIndex: "ngayYeuCauCoHangIn",
        key: "ngayYeuCauCoHangIn",
        width: 200,
        sorter: true,
        className: "!py-1",
        render: (text, record) => {
          return {
            props: {
              style: {
                textAlign: "center",
              },
            },
            children: record.ngayYeuCauCoHangIn
              ? moment(record.ngayYeuCauCoHangIn).format("DD/MM/YYYY HH:mm:ss")
              : "",
          };
        },
      },
      // Ngày yêu cầu nhập kho
      {
        title: "Ngày yêu cầu nhập kho",
        dataIndex: "ngayGiaoHang",
        key: "ngayGiaoHang",
        width: 150,
        sorter: true,
        className: "!py-1",
        render: (text, record) => {
          return {
            props: {
              style: {
                textAlign: "center",
              },
            },
            children: record.ngayGiaoHang
              ? moment(record.ngayGiaoHang).format("DD/MM/YYYY")
              : "",
          };
        },
      },
      // Ngày dự kiến hoàn thành lệnh
      {
        title: "Ngày dự kiến hoàn thành lệnh",
        dataIndex: "ngayDuKienHoanThanhLSX",
        key: "ngayDuKienHoanThanhLSX",
        width: 230,
        className: "!py-1",
        render: (text, record) => {
          return {
            props: {
              style: {
                textAlign: "center",
              },
            },
            children: record.ngayDuKienHoanThanhLSX
              ? moment(record.ngayDuKienHoanThanhLSX).format(
                "DD/MM/YYYY HH:mm:ss"
              )
              : "",
          };
        },
      },
      // TG thực tế hoàn thành coong đoạn in
      {
        title: "TG thực tế HT công đoạn in",
        dataIndex: "thoiGianThucTeHTCDIn",
        key: "thoiGianThucTeHTCDIn",
        width: 150,
        sorter: true,
        className: "!py-1",
        onCell: () => ({
          style: { textAlign: "center" },
        }),
        valueType: "dateTime",
        fieldProps: {
          format: "DD/MM/YYYY HH:mm",
        },
      },
      // Lệnh thiết kế
      {
        title: "Lệnh thiết kế",
        dataIndex: "matchCard",
        key: "matchCard",
        width: 150,
        className: "!py-1",
      },
      // Tên hạng mục in
      {
        title: "Tên hạng mục in",
        dataIndex: "printItem",
        key: "printItem",
        width: 250,
        className: "!py-1",
      },
      // Lệnh tổng hợp
      {
        title: "Lệnh tổng hợp",
        dataIndex: "parentWorkOrderCode",
        key: "parentWorkOrderCode",
        width: 200,
        className: "!py-1",
      },
      // TG thực tế HT lệnh
      {
        title: "TG thực tế HT lệnh",
        dataIndex: "tgThucTeHoanThanhLSX",
        key: "tgThucTeHoanThanhLSX",
        width: 150,
        sorter: true,
        className: "!py-1",
        render: (text, record) => {
          return {
            props: {
              style: {
                textAlign: "center",
              },
            },
            children: record.tgThucTeHoanThanhLSX
              ? moment(record.tgThucTeHoanThanhLSX).format(
                "DD/MM/YYYY HH:mm:ss"
              )
              : "",
          };
        },
      },
      // SL phát lệnh
      {
        title: "SL phát lệnh",
        dataIndex: "slPhatLenh",
        key: "slPhatLenh",
        width: 100,
        sorter: true,
        className: "!py-1",
        render: (text, record) => {
          return {
            props: {
              style: {
                textAlign: "right",
              },
            },
            children:
              text !== undefined && text !== null && text !== "-"
                ? formatNumber(record.slPhatLenh, 0)
                : "-",
          };
        },
      },
      // SL hàng in về xưởng (Tờ)
      // {
      //   title: "SL hàng in về xưởng\n(Tờ)",
      //   dataIndex: "slHangInVeXuongTheoTo",
      //   key: "slHangInVeXuongTheoTo",
      //   width: 100,
      //   sorter: true,
      //   className: "!py-1 whitespace-pre-line",
      //   onCell: (_, index) => ({
      //     style: {
      //       textAlign: "right",
      //     },
      //   }),
      //   render: (text, record) => {
      //     return text !== undefined && text !== null && text !== "-"
      //       ? formatNumber(record.slHangInVeXuongTheoTo, 0)
      //       : "-";
      //   },
      // },
      // SL hàng in về xưởng (sản phẩm)
      // {
      //   title: "SL hàng in về xưởng\n(Sản phẩm)",
      //   dataIndex: "slHangInVeXuongTheoSanPham",
      //   key: "slHangInVeXuongTheoSanPham",
      //   width: 100,
      //   sorter: true,
      //   className: "!py-1 whitespace-pre-line",
      //   onCell: (_, index) => ({
      //     style: {
      //       textAlign: "right",
      //     },
      //   }),
      //   render: (text, record) => {
      //     return text !== undefined && text !== null && text !== "-"
      //       ? formatNumber(record.slHangInVeXuongTheoSanPham, 0)
      //       : "-";
      //   },
      // },
      // SL hàng đạt công đoạn in (Tờ)
      {
        title: "SL hàng đạt công đoạn in (Tờ)",
        dataIndex: "slHangDatCongDoanInTheoTo",
        key: "slHangDatCongDoanInTheoTo",
        width: 100,
        sorter: true,
        className: "!py-1 whitespace-pre-line",
        onCell: (_, index) => ({
          style: {
            textAlign: "right",
          },
        }),
        render: (text, record) => {
          return text !== undefined && text !== null && text !== "-"
            ? formatNumber(record.slHangDatCongDoanInTheoTo, 0)
            : "-";
        },
      },
      // SL hàng đạt CĐ in (Sản phẩm)
      {
        title: "SL hàng đạt CĐ in (Sản phẩm)",
        dataIndex: "slHangDatCongDoanInTheoSanPham",
        key: "slHangDatCongDoanInTheoSanPham",
        width: 100,
        sorter: true,
        className: "!py-1 whitespace-pre-line",
        onCell: (_, index) => ({
          style: {
            textAlign: "right",
          },
        }),
        render: (text, record) => {
          return text !== undefined && text !== null && text !== "-"
            ? formatNumber(record.slHangDatCongDoanInTheoSanPham, 0)
            : "-";
        },
      },
      // Dvt
      {
        title: "ĐVT",
        dataIndex: "dvt",
        key: "dvt",
        width: 75,
        sorter: true,
        className: "!py-1",
      },
      // Bản vẽ SP
      {
        title: "Bản vẽ SP",
        dataIndex: "drawCode",
        key: "drawCode",
        width: 150,
        className: "!py-1",
        render: (text, record) => {
          return <AntdTooltip title={text}>{text}</AntdTooltip>;
        },
      },
      // Marquette
      {
        title: "Marquette",
        dataIndex: "marquette",
        key: "marquette",
        width: 150,
        className: "!py-1",
      },
      // Trạng thái lệnh
      {
        title: "Trạng thái lệnh",
        dataIndex: "trangThaiLSX",
        key: "trangThaiLSX",
        width: 150,
        className: "!py-1",
      },
      // Ghi chú trạng thái MES
      {
        title: "Ghi chú trạng thái MES",
        dataIndex: "ghiChuTrangThaiMes",
        key: "ghiChuTrangThaiMes",
        width: 150,
        className: "!py-1",
        render: (text, record) => {
          return <AntdTooltip title={text}>{text}</AntdTooltip>;
        },
      },
      // Thứ tự công đoạn
      {
        title: "Thứ tự công đoạn",
        dataIndex: "thuTuCongDoan",
        key: "thuTuCongDoan",
        width: 150,
        className: "!py-1",
        onCell: (cell, record) => ({
          style: {
            textAlign: "right",
          },
        }),
      },
      // Công đoạn
      {
        title: "Công đoạn",
        dataIndex: "congDoan",
        key: "congDoan",
        width: 100,
        className: "!py-1",
      },
      {
        title: "Trạng thái công đoạn",
        dataIndex: "workOrderRoutingStatus",
        key: "workOrderRoutingStatus",
        width: 150,
        className: "!py-1",
      },
      {
        title: "Số SP/Tờ/Công đoạn\n(Theo Routing)",
        dataIndex: "soSPToCongDoan",
        key: "soSPToCongDoan",
        width: 150,
        className: "!py-1",
        render: (text, record) => {
          return {
            props: {
              style: {
                textAlign: "right",
              },
            },
            children:
              text !== "-" && text !== undefined && text !== null
                ? formatNumber(Number(text), 2)
                : "-",
          };
        },
      },
      // % HT công đoạn
      {
        title: "% HT công đoạn",
        dataIndex: "percentHTCongDoan",
        key: "percentHTCongDoan",
        width: 150,
        className: "!py-1",
        render: (text, record) => {
          return {
            props: {
              style: {
                textAlign: "right",
              },
            },
            children:
              text !== "-" && text !== undefined && text !== null
                ? formatNumber(Number(text), 2) + "%"
                : "-",
          };
        },
      },
      // Tick hoàn thành công đoạn
      {
        title: "Tick hoàn thành công đoạn",
        dataIndex: "tickHTCD",
        key: "tickHTCD",
        width: 200,
        className: "!py-1",
        onCell: (record) => ({
          style: {
            textAlign: "center",
          },
        }),
      },
      // NVL sử dụng
      {
        title: "NVL sử dụng",
        dataIndex: "nvlSuDung",
        key: "nvlSuDung",
        width: 200,
        className: "!py-1",
        render: (text, record) => {
          return <AntdTooltip title={text}>{text}</AntdTooltip>;
        },
      },
      // Khuôn sử dụng (kế hoạch)
      {
        title: "Khuôn sử dụng (kế hoạch)",
        dataIndex: "khuonKeHoach",
        key: "khuonKeHoach",
        width: 200,
        className: "!py-1",
        render: (text, record) => {
          return <AntdTooltip title={text}>{text}</AntdTooltip>;
        },
      },
      // Hướng dẫn SX
      {
        title: "Hướng dẫn SX",
        dataIndex: "hdsx",
        key: "hdsx",
        width: 150,
        className: "!py-1",
        render: (text, record) => {
          return <AntdTooltip title={text}>{text}</AntdTooltip>;
        },
      },
      // SL sản phẩm đạt
      {
        title: "SL sản phẩm đạt",
        dataIndex: "slSanPhamDat",
        key: "slSanPhamDat",
        width: 150,
        className: "!py-1",
        render: (text, record) => {
          return {
            props: {
              style: {
                textAlign: "right",
              },
            },
            children:
              text !== "-" && text !== undefined && text !== null
                ? formatNumber(Number(text), 1)
                : "-",
          };
        },
      },
      // SL sản phẩm lỗi
      {
        title: "SL sản phẩm lỗi",
        dataIndex: "slSanPhamLoi",
        key: "slSanPhamLoi",
        width: 150,
        className: "!py-1",
        render: (text, record) => {
          return {
            props: {
              style: {
                textAlign: "right",
              },
            },
            children:
              text !== "-" && text !== undefined && text !== null
                ? formatNumber(Number(text), 1)
                : "-",
          };
        },
      },

      // Thời gian còn lại\n(Tính theo sản lượng thực tế của các công đoạn sau gia công in)
      {
        title:
          "Thời gian còn lại\n(Tính theo sản lượng thực tế của các công đoạn sau gia công in)",
        className: "!py-1 whitespace-pre-line",
        key: "tgConLai2",
        children: [
          {
            title: "Giờ",
            dataIndex: "soGioConLai2",
            key: "soGioConLai2",
            width: 150,
            className: "!py-1",
            fieldProps: {
              moneySymbol: false,
              precision: 0,
            },
            render: (text, record) => text !== '-' ? formatNumber(Number(text), 0) : text,

            onCell: (record) => ({
              style: {
                textAlign: "right",
              },
            }),
          },
          {
            title: "Phút",
            dataIndex: "soPhutConLai2",
            key: "soPhutConLai2",
            width: 150,
            className: "!py-1",
            fieldProps: {
              moneySymbol: false,
              precision: 0,
            },
            render: (text, record) => text !== '-' ? formatNumber(Number(text), 0) : text,
            onCell: (record) => ({
              style: {
                textAlign: "right",
              },
            }),
          },
        ],
      },

      // TG đã sản xuất kế hoạch (Không tính công đoạn gia công in)
      {
        title: "TG đã sản xuất kế hoạch\n(Không tính công đoạn gia công in)",
        width: 200,
        className: "!py-1 whitespace-pre-line",
        children: [
          {
            title: "Giờ",
            dataIndex: "soGioSXKH",
            width: 100,

            key: "soGioSXKH",
            className: "!py-1",

            render: (text, record) => {
              return {
                props: {
                  style: {
                    textAlign: "right",
                  },
                },
                children: text !== "-" ? formatNumber(Number(text), 0) : "-",
              };
            },
          },
          {
            title: "Phút",
            dataIndex: "soPhutSXKH",
            width: 100,

            key: "soPhutSXKH",
            className: "!py-1",
            render: (text, record) => {
              return {
                props: {
                  style: {
                    textAlign: "right",
                  },
                },
                children: text !== "-" ? formatNumber(Number(text), 0) : "-",
              };
            },
          },
        ],
      },
      {
        title:
          "TG đã sản xuất thực tế\n(Có tính công đoạn gia công in, đã nhân tỷ lệ ghép bài)",
        width: 200,
        className: "!py-1 whitespace-pre-line",
        key: "tgDaSXThucTe",
        children: [
          {
            title: "Giờ",
            dataIndex: "soGioSXTT",
            width: 100,

            key: "soGioSXTT",
            className: "!py-1",
            render: (text, record) => {
              return {
                props: {
                  style: {
                    textAlign: "right",
                  },
                },
                children: text !== "-" ? formatNumber(Number(text), 0) : "-",
              };
            },
          },
          {
            title: "Phút",
            dataIndex: "soPhutSXTT",
            width: 100,

            key: "soPhutSXTT",
            className: "!py-1",

            render: (text, record) => {
              return {
                props: {
                  style: {
                    textAlign: "right",
                  },
                },
                children: text !== "-" ? formatNumber(Number(text), 0) : "-",
              };
            },
          },
        ],
      },
      // TG chênh lệch (Giờ)
      {
        title: "TG chênh lệch (Giờ)",
        width: 200,
        key: "tgChenhLech",
        className: "!py-1",
        children: [
          {
            title: "Giờ",
            dataIndex: "soGioChenhLech",
            width: 100,

            key: "soGioChenhLech",
            className: "!py-1",
            render: (text, record) => {
              return {
                props: {
                  style: {
                    textAlign: "right",
                    backgroundColor: Number(text) < 0 ? "#FF8081" : "#FFFFFF",
                  },
                },
                children: text !== "-" ? formatNumber(Number(text), 0) : "-",
              };
            },
          },
          {
            title: "Phút",
            dataIndex: "soPhutChenhLech",
            width: 100,

            key: "soPhutChenhLech",
            className: "!py-1",
            render: (text, record) => {
              return {
                props: {
                  style: {
                    textAlign: "right",
                    backgroundColor: Number(text) < 0 ? "#FF8081" : "#FFFFFF",
                  },
                },
                children: text !== "-" ? formatNumber(Number(text), 0) : "-",
              };
            },
          },
        ],
      },

      //================ CHI TIẾT ========================================================
      // Chuyền/nhóm máy thực hiện
      {
        title: "Chuyền/nhóm máy thực hiện",
        className: "!py-1",
        dataIndex: ["chiTietBaoCao", "tenBarcode"],
        key: "tenBarcode",
        width: 230,
        hideInTable: true,
        hideInSetting: true,
        render: (text, record) => {
          return <AntdTooltip title={text}>{text}</AntdTooltip>;
        },
      },
      // Ngày SX
      {
        title: "Ngày SX",
        dataIndex: ["chiTietBaoCao", "ngaySanXuat"],
        key: "ngaySanXuat",
        width: 150,
        className: "!py-1",
        hideInTable: true,
        hideInSetting: true,
        render: (text, record) => {
          return {
            props: {
              style: {
                textAlign: "center",
              },
            },
            children: text,
          };
        },
      },
      //  TG bắt đầu
      {
        title: "TG bắt đầu",
        dataIndex: ["chiTietBaoCao", "thoiGianBatDau"],
        key: "thoiGianBatDau",
        width: 150,
        className: "!py-1",
        hideInTable: true,
        hideInSetting: true,
        render: (text, record) => {
          return {
            props: {
              style: {
                textAlign: "center",
              },
            },
            children:
              text && text !== "-"
                ? moment(`${text}`).format("DD/MM/YYYY HH:mm")
                : "-",
          };
        },
      },
      // TG kết thúc
      {
        title: "TG kết thúc",
        dataIndex: ["chiTietBaoCao", "thoiGianKetThuc"],
        key: "thoiGianKetThuc",
        width: 150,
        className: "!py-1",
        hideInTable: true,
        hideInSetting: true,
        render: (text, record) => {
          return {
            props: {
              style: {
                textAlign: "center",
              },
            },
            children:
              text && text !== "-"
                ? moment(`${text}`).format("DD/MM/YYYY HH:mm")
                : "-",
          };
        },
      },
      // Tỷ lệ ghép bài
      {
        title: "Tỷ lệ ghép bài",
        className: "!py-1",
        dataIndex: ["chiTietBaoCao", "tyLeGhepBai"],
        key: "tyLeGhepBai",
        width: 150,
        hideInTable: true,
        hideInSetting: true,
        render: (text, record) => {
          return {
            props: {
              style: {
                textAlign: "right",
              },
            },
            children: text,
          };
        },
      },
      // TG thực hiện (Theo lần ghi nhận, đã nhân tỷ lệ ghép bài)
      {
        title: "TG thực hiện\n(Theo lần ghi nhận, đã nhân tỷ lệ ghép bài)",
        key: "tgThucHienLanGhiNhan",
        className: "!py-1 whitespace-pre-line",
        hideInTable: true,
        hideInSetting: true,
        children: [
          {
            title: "Giờ",
            dataIndex: ["chiTietBaoCao", "soGioThucHien"],
            key: "soGioThucHien",
            width: 150,
            className: "!py-1",
            render: (text, record) => {
              return {
                props: {
                  style: {
                    textAlign: "right",
                  },
                },
                children: text !== "-" ? formatNumber(Number(text), 0) : "-",
              };
            },
          },
          {
            title: "Phút",
            dataIndex: ["chiTietBaoCao", "soPhutThucHien"],
            key: "soPhutThucHien",
            width: 150,
            className: "!py-1",
            // hideInTable: true,
            // hideInSetting: true,
            render: (text, record) => {
              return {
                props: {
                  style: {
                    textAlign: "right",
                  },
                },
                children:
                  text !== "-" && text !== undefined && text !== null
                    ? formatNumber(Number(text), 0)
                    : "-",
              };
            },
          },
        ],
      },
      // SL ghi nhận
      {
        title: "SL ghi nhận",
        dataIndex: ["chiTietBaoCao", "slGhiNhan"],
        key: "slGhiNhan",
        width: 150,
        className: "!py-1",
        hideInTable: true,
        hideInSetting: true,
        render: (text, record) => {
          return {
            props: {
              style: {
                textAlign: "right",
              },
            },
            children:
              text !== "-" && text !== undefined && text !== null
                ? formatNumber(Number(text), 1)
                : "-",
          };
        },
      },
      // ĐVT công đoạn
      {
        title: "ĐVT công đoạn",
        dataIndex: ["chiTietBaoCao", "dvtCongDoan"],
        key: "dvtCongDoan",
        width: 150,
        className: "!py-1",
        hideInTable: true,
        hideInSetting: true,
      },
      // Số SP/tờ/CĐ
      {
        title: "Số SP/tờ/CĐ",
        dataIndex: ["chiTietBaoCao", "spToCongDoan"],
        key: "spToCongDoan",
        width: 150,
        className: "!py-1",
        hideInTable: true,
        hideInSetting: true,
        render: (text, record) => {
          return {
            props: {
              style: {
                textAlign: "right",
              },
            },
            children:
              text !== "-" && text !== undefined && text !== null
                ? formatNumber(Number(text), 2)
                : "-",
          };
        },
      },
      // SL ghi nhận (pcs)
      {
        title: "SL ghi nhận (pcs)",
        dataIndex: ["chiTietBaoCao", "slGhiNhanPCS"],
        key: "slGhiNhanPCS",
        width: 150,
        className: "!py-1",
        hideInTable: true,
        hideInSetting: true,
        render: (text, record) => {
          return {
            props: {
              style: {
                textAlign: "right",
              },
            },
            children:
              text !== "-" && text !== undefined && text !== null
                ? formatNumber(Number(text), 1)
                : "-",
          };
        },
      },
      // ĐVT
      {
        title: "ĐVT",
        dataIndex: ["chiTietBaoCao", "dvT2"],
        key: "dvT2",
        width: 150,
        className: "!py-1",
        hideInTable: true,
        hideInSetting: true,
      },
      // Số tờ/nhịp bế
      {
        title: "Số tờ/nhịp bế",
        dataIndex: ["chiTietBaoCao", "soToTrenNhipBe"],
        key: "soToTrenNhipBe",
        width: 150,
        className: "!py-1",
        hideInTable: true,
        hideInSetting: true,
        render: (text, record) => {
          return {
            props: {
              style: {
                textAlign: "right",
              },
            },
            children:
              text !== "-" && text !== undefined && text !== null
                ? formatNumber(Number(text), 1)
                : "-",
          };
        },
      },
      // Khuôn sử dụng
      {
        title: "Khuôn sử dụng",
        dataIndex: ["chiTietBaoCao", "khuonSuDung"],
        key: "khuonSuDung",
        width: 200,
        className: "!py-1",
        hideInTable: true,
        hideInSetting: true,
        render: (text, record) => {
          return <AntdTooltip title={text}>{text}</AntdTooltip>;
        },
      },
      // SL nhân công kế hoạch
      {
        title: "SL nhân công kế hoạch",
        dataIndex: ["chiTietBaoCao", "slNhanCongKeHoach"],
        key: "slNhanCongKeHoach",
        width: 150,
        className: "!py-1",
        hideInTable: true,
        hideInSetting: true,
        render: (text, record) => {
          return {
            props: {
              style: {
                textAlign: "right",
              },
            },
            children:
              text !== undefined && text !== "-"
                ? formatNumber(Number(text), 0)
                : "-",
          };
        },
      },
      // SL nhân viên TH
      {
        title: "SL nhân viên TH",
        dataIndex: ["chiTietBaoCao", "slNhanVienThucHien"],
        key: "slNhanVienThucHien",
        width: 150,
        className: "!py-1",
        hideInTable: true,
        hideInSetting: true,
        render: (text, record) => {
          return {
            props: {
              style: {
                textAlign: "right",
              },
            },
            children:
              text !== undefined && text !== "-"
                ? formatNumber(Number(text), 0)
                : "-",
          };
        },
      },
      // Nhân viên thực hiện
      {
        title: "Nhân viên thực hiện",
        dataIndex: ["chiTietBaoCao", "nhanVienThucHien"],
        key: "nhanVienThucHien",
        width: 150,
        className: "!py-1",
        hideInTable: true,
        hideInSetting: true,
        render: (text, record) => {
          return <AntdTooltip title={text}>{text}</AntdTooltip>;
        },
      },
      // Tổng giờ công (Giờ)\n(TG thực hiện*SL nhân viên thực hiện)
      {
        title: "Tổng giờ công (Giờ)\n(TG thực hiện*SL nhân viên thực hiện)",
        dataIndex: ["chiTietBaoCao", "tongGioCong"],
        key: "tongGioCong",
        width: 200,
        className: "!py-1 whitespace-pre-line",
        hideInTable: true,
        hideInSetting: true,

        render: (text, record) => {
          return {
            props: {
              style: {
                textAlign: "right",
              },
            },
            children:
              text && text !== "-" ? formatNumber(Number(text), 2) : "-",
          };
        },
      },
      // Ghi chú
      {
        title: "Ghi chú",
        dataIndex: ["chiTietBaoCao", "ghiChu"],
        key: "ghiChu",
        width: 150,
        className: " !py-1",
        hideInTable: true,
        hideInSetting: true,
        render: (text, record) => {
          return <AntdTooltip title={text}>{text}</AntdTooltip>;
        },
      },
    ]);

    const tableRef = useRef<ActionType>();

    // dropdown khách hàng
    const [dropdownCustomer, setDropdownCustomer] = useState<ListStatusProduct[]>([])
    // Lấy danh sách khách hàng
    const getListCustomer = async (keword?: string) => {
      await rootStore.commonDatePresenter.getListCustomer(commonDateStore, keword);
      if (commonDateStore.listStatusProductResponse.isSuccess) {
        setDropdownCustomer(commonDateStore.listStatusProductResponse.data)
      }
    }

    const searchCustomer = useCallback(debounce(getListCustomer, 500), []);



    // Name data save to localstorage
    const constDataName = "bc-07";

    const {
      isResizablePresent,
      resizableColumnSelect,
      columnsState,
      handleColumnsStateChange,
      templateReportModalRef,
      userReports,
      selectedReportId,
      templateReportModalProps,
      setIsResizablePresent,
      handleResize,
    } = useResizableColumns<BC07>(columns, setColumn, constDataName);

    //=======================XXX========================XXX=========================XXX========================= //

    //=======================================================================
    //======================================================================= RETURN ZONE
    //=======================================================================
    return (
      <div className="w-full py-3 px-5">
        <SearchCollapse title="BC 07. TỈ LỆ HOÀN THÀNH TỪNG CÔNG ĐOẠN">
          {/* Form nhập tìm kiếm */}
          <form
            onSubmit={handleSubmit(onSearch)}
            className="w-full px-8 h-full py-2 lg:grid lg:grid-cols-2 flex flex-col gap-y-2"
          >
            {/* Chọn LSX */}
            <div className="w-full sm:items-center grid grid-cols-3">
              <CustomSelect
                mode="multiple"
                title="Lệnh sản xuất"
                placeholder="Chọn lệnh sản xuất"
                data={listLSX}
                onChangeValue={handleChangeSelectMul}
                idKey="lsx"
                showSearch
                allowClear
                onDeselect={() => setListLSX([])}
                onClear={() => setListLSX([])}
                onSearch={async (value) => await debounceLSX(value)}
              />
            </div>
            {/* Thành phẩm / BTP */}
            <div className="w-full sm:items-center grid grid-cols-3">
              <CustomSelect
                title="TP/BTP"
                data={dropdownProduct}
                onChangeValue={handleChangeSelect}
                idKey="tpbtp"
                showSearch
                allowClear
                placeholder="Chọn TP/BTP"
                onClear={() => setDropdownProduct([])}
                onDeselect={() => setDropdownProduct([])}
                onSearch={async (value) => await debounceProduct(value)}
              />
            </div>

            {/* Chọn trạng thái */}
            <div className="w-full sm:items-center grid grid-cols-3">
              <CustomSelect
                mode="multiple"
                title="Trạng thái LSX MES"
                data={listStatus}
                defaultValue={{ key: "CLOSED", value: "Đóng lệnh" }}
                onChangeValue={handleChangeSelectMul}
                idKey="trangThaiMES"
                allowClear
                placeholder="--Tất cả--"
              />
            </div>
            {/* Công đoạn */}
            <div className="w-full sm:items-center grid grid-cols-3">
              <CustomSelect
                mode="multiple"
                title="Công đoạn"
                data={listRouting}
                value={dataSearch.listStepCode}
                maxTagCount="responsive"
                onChangeValue={handleChangeListStep}
                filterOption={false}
                onSearch={async (value) => await debounceListRouting(value)}
                onClear={() => { setSelectAllRouting(false); getDataDropdownRouting() }}
                idKey="listStepCode"
                placeholder="Chọn công đoạn"
                allowClear
                fieldNames={{
                  label: "stepName",
                  value: "stepCode",
                }}
                // Tạo nút select all
                dropdownRender={(menu) => (
                  <>
                    {menu}
                    <Divider style={{ margin: "8px 0" }} />
                    <Space style={{ padding: "0 8px 4px" }}>
                      <Checkbox
                        checked={selectAllRouting}
                        onChange={(e) => {
                          setSelectAllRouting(e.target.checked)
                          if (e.target.checked) {
                            setDataSearch({
                              ...dataSearch,
                              listStepCode: listRouting.map((i) => i.stepCode),
                            });
                          } else {
                            setDataSearch({ ...dataSearch, listStepCode: [] });
                          }
                        }}
                      >
                        Chọn tất cả
                      </Checkbox>
                    </Space>
                  </>
                )}
              />
            </div>
            {/* Lệnh sản xuất vệ sinh */}
            <div className="w-full sm:items-center grid grid-cols-3">
              <label className="min-w-[150px] font-bold text-default text-black sm:text-end">
                Lệnh sản xuất vệ sinh
              </label>

              <div className="col-span-2 sm:ml-5 text-default flex gap-x-4 gap-y-2 flex-wrap">
                <Radio.Group
                  onChange={(e: RadioChangeEvent) => {
                    setDataSearch({
                      ...dataSearch,
                      lsxVeSinh: e.target.value,
                    });
                  }}
                  value={dataSearch.lsxVeSinh}
                >
                  <Radio className="!text-default" value={true}>
                    Có xem
                  </Radio>
                  <Radio className="!text-default" value={false}>
                    Không xem
                  </Radio>
                  <Radio className="!text-default"  >
                    Tất cả
                  </Radio>
                </Radio.Group>
              </div>
            </div>
            {/* Khách hàng */}
            <div className="w-full sm:items-center grid grid-cols-3">
              <CustomSelect
                title="Khách hàng"
                placeholder="Chọn khách hàng"
                data={dropdownCustomer}
                onChangeValue={handleChangeSelect}
                idKey="khachHang"
                showSearch
                allowClear
                onDeselect={() => setDropdownCustomer([])}
                onClear={() => setDropdownCustomer([])}
                onSearch={async (value) => await searchCustomer(value)}
              />
            </div>
            {/* Trạng thái công đoạn */}
            <div className="w-full sm:items-center grid grid-cols-3">
              <CustomSelect
                title="Trạng thái công đoạn"
                data={listWORoutingStatus}
                onChangeValue={handleChangeSelect}
                idKey="workOrderRoutingStatus"
                allowClear
                placeholder="--Tất cả--"
              />
            </div>
            {/* Chọn Thời gian phát lệnh */}
            <div className="w-full sm:items-center grid grid-cols-3 col-start-1">
              <CustomSelect
                title="Ngày ban hành LSX"
                data={commonDate}
                onChangeValue={handleChangeSelect}
                idKey="pickedDateLSX"
                showSearch
                allowClear
                placeholder="Chọn khoảng thời gian"
              />
            </div>

            {/* từ ngày */}
            <div className="w-full sm:flex-row sm:items-center grid grid-cols-3 col-start-1">
              <label
                htmlFor="tgPhatLenhTu"
                className="min-w-[150px] font-bold text-default text-black sm:text-end"
              >
                Từ ngày
              </label>

              <DatePicker
                id="tgPhatLenhTu"
                className="col-span-2 sm:!ml-5 "
                // Trigger change when blur. e.g. datetime picker no need click confirm button
                changeOnBlur
                disabled={
                  pickedDate.pickedDateLSX !== "Custom" &&
                  pickedDate.pickedDateLSX !== ""
                }
                value={
                  dataSearch.tgPhatLenhTu
                    ? dayjs(dataSearch.tgPhatLenhTu)
                    : undefined
                }
                format={"DD/MM/YYYY"}
                placeholder="dd/mm/yyyy"
                onChange={(date, dateString) => {
                  const pickDate =
                    dateString !== ""
                      ? dayjs(date).format("YYYY-MM-DD")
                      : undefined;
                  setDataSearch({ ...dataSearch, tgPhatLenhTu: pickDate });
                }}
              />
            </div>
            {/* đến ngày */}
            <div className="w-full sm:flex-row sm:items-center grid grid-cols-3">
              <label
                htmlFor="tgPhatLenhDen"
                className="min-w-[150px] font-bold text-default text-black sm:text-end"
              >
                Đến ngày
              </label>

              <DatePicker
                id="tgPhatLenhDen"
                className="col-span-2 sm:!ml-5 "
                // Trigger change when blur. e.g. datetime picker no need click confirm button
                changeOnBlur
                disabled={
                  pickedDate.pickedDateLSX !== "Custom" &&
                  pickedDate.pickedDateLSX !== ""
                }
                value={
                  dataSearch.tgPhatLenhDen
                    ? dayjs(dataSearch.tgPhatLenhDen)
                    : undefined
                }
                format={"DD/MM/YYYY"}
                placeholder="dd/mm/yyyy"
                onChange={(date, dateString) => {
                  const pickDate =
                    dateString !== ""
                      ? dayjs(date).format("YYYY-MM-DD")
                      : undefined;
                  setDataSearch({ ...dataSearch, tgPhatLenhDen: pickDate });
                }}
              />
            </div>

            {/* Chọn Thời gian hoàn thành lệnh */}
            <div className="w-full sm:items-center grid grid-cols-3">
              <CustomSelect
                title="Thời gian hoàn thành lệnh"
                data={commonDate}
                value={commonDate.find(
                  (date) => date.key === pickedDate.pickedDateNGH
                )}
                onChangeValue={handleChangeSelect}
                idKey="pickedDateNGH"
                showSearch
                allowClear
                placeholder="Chọn khoảng thời gian"
              />
            </div>

            {/* từ ngày */}
            <div className="w-full sm:flex-row sm:items-center grid grid-cols-3 col-start-1">
              <label
                htmlFor="tgHoanThanhLSXTu"
                className="min-w-[150px] font-bold text-default text-black sm:text-end"
              >
                Từ ngày
              </label>

              <DatePicker
                id="tgHoanThanhLSXTu"
                className="col-span-2 sm:!ml-5 "
                // Trigger change when blur. e.g. datetime picker no need click confirm button
                changeOnBlur
                disabled={
                  pickedDate.pickedDateNGH !== "Custom" &&
                  pickedDate.pickedDateNGH !== ""
                }
                value={
                  dataSearch.tgHoanThanhLSXTu
                    ? dayjs(dataSearch.tgHoanThanhLSXTu)
                    : undefined
                }
                format={"DD/MM/YYYY"}
                placeholder="dd/mm/yyyy"
                onChange={(date, dateString) => {
                  const pickDate =
                    dateString !== ""
                      ? dayjs(date).format("YYYY-MM-DD")
                      : undefined;
                  setDataSearch({ ...dataSearch, tgHoanThanhLSXTu: pickDate });
                }}
              />
            </div>
            {/* đến ngày */}
            <div className="w-full sm:flex-row sm:items-center grid grid-cols-3">
              <label
                htmlFor="tgHoanThanhLSXDen"
                className="min-w-[150px] font-bold text-default text-black sm:text-end"
              >
                Đến ngày
              </label>

              <DatePicker
                id="tgHoanThanhLSXDen"
                className="col-span-2 sm:!ml-5 "
                // Trigger change when blur. e.g. datetime picker no need click confirm button
                changeOnBlur
                disabled={
                  pickedDate.pickedDateNGH !== "Custom" &&
                  pickedDate.pickedDateNGH !== ""
                }
                value={
                  dataSearch.tgHoanThanhLSXDen
                    ? dayjs(dataSearch.tgHoanThanhLSXDen)
                    : undefined
                }
                format={"DD/MM/YYYY"}
                placeholder="dd/mm/yyyy"
                onChange={(date, dateString) => {
                  const pickDate =
                    dateString !== ""
                      ? dayjs(date).format("YYYY-MM-DD")
                      : undefined;
                  setDataSearch({ ...dataSearch, tgHoanThanhLSXDen: pickDate });
                }}
              />
            </div>

            {/* Xem theo */}
            <div className="w-full sm:flex-row sm:items-center grid grid-cols-3">
              <label className="min-w-[150px] font-bold text-default text-black sm:text-end">
                Xem theo
              </label>
              <div className="col-span-2 sm:ml-5 text-default flex gap-x-4 gap-y-2 flex-wrap">
                <Radio.Group
                  onChange={(e: RadioChangeEvent) => {
                    const temp = cloneDeep(dataSearch);
                    Object.assign(temp, {
                      type: e.target.value,
                      ngaySanXuatTu: undefined,
                      ngaySanXuatDen: undefined,
                      nhanViens: [],
                      equipmentCode: []
                    });
                    setDataSearch(temp);
                  }}
                  value={dataSearch.type}
                >
                  <Radio className="!text-default" value={"TH"}>
                    Tổng hợp
                  </Radio>
                  <Radio className="!text-default" value={"CT"}>
                    Chi tiết công đoạn
                  </Radio>
                </Radio.Group>
              </div>
            </div>

            {dataSearch.type === "CT" ? (
              <>
                {/* Chọn Thời gian sản xuất  */}
                <div className={"w-full sm:items-center grid grid-cols-3 col-start-1 "}>
                  <CustomSelect
                    title="Thời gian sản xuất"
                    data={commonDate}
                    onChangeValue={handleChangeSelect}
                    value={commonDate.find(
                      (item) => item.key === pickedDate.pickedDateTGSX
                    )}
                    idKey="tgSanXuat"
                    showSearch
                    allowClear
                    placeholder="Chọn khoảng thời gian"
                  />
                </div>

                {/* từ ngày */}
                <div className="w-full sm:flex-row sm:items-center grid grid-cols-3 col-start-1">
                  <label
                    htmlFor="ngaySanXuatTu"
                    className="min-w-[150px] font-bold text-default text-black sm:text-end"
                  >
                    Từ ngày
                  </label>

                  <DatePicker
                    id="ngaySanXuatTu"
                    className="col-span-2 sm:!ml-5 "
                    // Trigger change when blur. e.g. datetime picker no need click confirm button
                    changeOnBlur
                    disabled={
                      pickedDate.pickedDateTGSX !== "Custom" &&
                      pickedDate.pickedDateTGSX !== ""
                    }
                    value={
                      dataSearch.ngaySanXuatTu
                        ? dayjs(dataSearch.ngaySanXuatTu)
                        : undefined
                    }
                    format={"DD/MM/YYYY"}
                    placeholder="dd/mm/yyyy"
                    onChange={(date, dateString) => {
                      const pickDate =
                        dateString !== ""
                          ? dayjs(date).format("YYYY-MM-DD")
                          : undefined;
                      setDataSearch({ ...dataSearch, ngaySanXuatTu: pickDate });
                    }}
                  />
                </div>
                {/* đến ngày */}
                <div className="w-full sm:flex-row sm:items-center grid grid-cols-3">
                  <label
                    htmlFor="ngaySanXuatDen"
                    className="min-w-[150px] font-bold text-default text-black sm:text-end"
                  >
                    Đến ngày
                  </label>

                  <DatePicker
                    id="ngaySanXuatDen"
                    className="col-span-2 sm:!ml-5 "
                    // Trigger change when blur. e.g. datetime picker no need click confirm button
                    changeOnBlur
                    disabled={
                      pickedDate.pickedDateTGSX !== "Custom" &&
                      pickedDate.pickedDateTGSX !== ""
                    }
                    value={
                      dataSearch.ngaySanXuatDen
                        ? dayjs(dataSearch.ngaySanXuatDen)
                        : undefined
                    }
                    format={"DD/MM/YYYY"}
                    placeholder="dd/mm/yyyy"
                    onChange={(date, dateString) => {
                      const pickDate =
                        dateString !== ""
                          ? dayjs(date).format("YYYY-MM-DD")
                          : undefined;
                      setDataSearch({
                        ...dataSearch,
                        ngaySanXuatDen: pickDate,
                      });
                    }}
                  />
                </div>

                {/* Chọn nhân viên */}
                <div className="w-full sm:items-center grid grid-cols-3">
                  <CustomSelect
                    title="Nhân viên"
                    mode="multiple"
                    data={listEmployee}
                    onChangeValue={(value, option) => {
                      if (option && Array.isArray(option)) {
                        setDataSearch({
                          ...dataSearch,
                          nhanViens: option.map((val) => {
                            return val.key;
                          }),
                        });
                      } else {
                        setDataSearch({
                          ...dataSearch,
                          nhanViens: [],
                        });
                      }
                    }}
                    idKey="nhanvien"
                    showSearch
                    allowClear
                    placeholder="Chọn nhân viên"
                    onClear={async () => await getListEmployees()}
                    onSearch={async (value) => await debounceEmployees(value)}
                  />
                </div>
                <div className="w-full sm:items-center grid grid-cols-3">
                  <CustomSelect
                    title="Máy/chuyền thực hiện"
                    mode="multiple"
                    data={listEquip}
                    onChangeValue={(value, option) => {
                      if (option && Array.isArray(option)) {
                        setDataSearch({
                          ...dataSearch,
                          equipmentCode: option.map((val) => {
                            return val.key;
                          }),
                        });
                      } else {
                        setDataSearch({
                          ...dataSearch,
                          equipmentCode: [],
                        });
                      }
                    }}
                    idKey="mayChuyen"
                    showSearch
                    allowClear
                    placeholder="Chọn máy/chuyền"
                    onSearch={(value) => debounceListEquipcard(value)}
                  />
                </div>
              </>
            ) : (
              ""
            )}

            {/* button tìm kiếm */}
            <div className="mt-2 w-full flex justify-center col-span-2">
              <Button
                type="primary"
                loading={isLoading}
                htmlType="submit"
                // onClick={handleSubmit(onSearch)}
                className="bg-primary !flex justify-between items-center gap-2 !px-3 !rounded-sm !py-1"
              >
                Chạy báo cáo
              </Button>
            </div>
          </form>
        </SearchCollapse>

        <Wrapper>
          {isReady ? (
            <CustomProTable<BC07>
              columns={columns}
              handleResize={handleResize}
              isResizablePresent={isResizablePresent}
              resizableColumnSelect={resizableColumnSelect}
              className="[&_.ant-table-row-level-0>td]:!bg-[#ADE498]"

              headerTitle={<>
                {/* bảng chú thích */}
                <table
                  width={300}
                  className="h-fit bg-white text-default table-auto space-collapse"
                >
                  <thead className="text-white !bg-[#1677ff]">
                    <tr>
                      <th
                        className="font-semibold border border-border_input py-1"
                      >
                        Màu sắc
                      </th>
                      <th
                        className="font-semibold border border-border_input"
                      >
                        Diễn giải
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td
                        className={`px-2 border border-border_input bg-[#FF8081]`}
                        width={100}
                      >
                      </td>
                      <td
                        className={"border border-border_input px-2 py-1"}
                      >
                        {`TGSX thực tế > TGSX kế hoạch`}
                      </td>
                    </tr>
                    <tr>
                      <td
                        className={`px-2 border border-border_input bg-[#ade498]`}
                        width={100}
                      >
                      </td>
                      <td
                        className={"border border-border_input px-2 py-1"}
                      >
                        {`Phân biệt WO`}
                      </td>
                    </tr>
                    <tr>
                      <td
                        className={`px-2 border border-border_input bg-[#fff]`}
                        width={100}
                      >
                      </td>
                      <td
                        className={"border border-border_input px-2 py-1"}
                      >
                        {`Phân biệt CĐSX`}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </>}
              loading={isLoading}
              request={async (params = {}, sort, filter) => {
                setIsLoading(true);
                const data = await getDataAPI({
                  ...dataSearch,
                  paging: {
                    ...dataSearch.paging,
                    orderBy:
                      Object.values(sort)[0] === "ascend"
                        ? `${Object.keys(sort)[0].split(",").pop()}`
                        : "",
                    orderByDesc:
                      Object.values(sort)[0] === "descend"
                        ? `${Object.keys(sort)[0].split(",").pop()}`
                        : "",
                  },
                });
                if (Object.values(sort).length) {
                  setDataSearch({
                    ...dataSearch,
                    paging: {
                      ...dataSearch.paging,
                      orderBy:
                        Object.values(sort)[0] === "ascend"
                          ? `${Object.keys(sort)[0].split(",").pop()}`
                          : "",
                      orderByDesc:
                        Object.values(sort)[0] === "descend"
                          ? `${Object.keys(sort)[0].split(",").pop()}`
                          : "",
                    },
                  });
                }
                setIsLoading(false);
                return {
                  data: data,
                  success: rootStore.reportStore.BC07Response.isSuccess,
                };
              }}
              dataSource={dataTable.map((data) => data)}
              actionRef={tableRef} // Gán biến tham chiếu cho instance của bảng
              columnsState={{
                value: Object.keys(columnsState).length > 0 ? columnsState : {},
                onChange: (newColumnsState) => {
                  handleColumnsStateChange(newColumnsState);
                },
              }}
              // rowKey="stt"

              expandable={{
                expandedRowKeys: [...dataTable.map((i) => i.stt + "")],
                expandIcon: () => {
                  return <></>;
                },
              }}
              pagination={{
                pageSize: dataSearch.paging.pageSize,
                total: rootStore.reportStore.BC07Response.paging?.totalCount,
                current: dataSearch.paging.pageIndex,
                responsive: true,
                pageSizeOptions: [10, 25, 50, 100],
                showSizeChanger: true,
                position: ["topRight", "bottomRight"],
                style: { margin: "10px 0" },
                showTotal: (total, range) =>
                  `Hiển thị ${range[0]}-${range[1]} của ${total} mục`,
                onChange: (page, pageSize) => {
                  setDataSearch({
                    ...dataSearch,
                    paging: {
                      ...dataSearch.paging,
                      pageIndex: page,
                      pageSize: pageSize,
                    },
                  });
                },
              }}
              toolBarRender={() => [
                <Button
                  size="middle"
                  loading={isLoading}
                  className="bg-primary !flex justify-between items-center gap-2 !px-3 !rounded-sm !py-1"
                  onClick={async () => {
                    setIsLoading(true);
                    await rootStore.reportPresenter.exportExcelBC07({
                      ...dataSearch,
                    });
                    setIsLoading(false);
                  }}
                  type="primary"
                >
                  <AiOutlineDownload className="block text-base" />
                  <span className="block">Export Excel</span>
                </Button>,
                <SaveReportForm
                  templateReportModalRef={templateReportModalRef}
                  userReports={userReports}
                  selectedReportId={selectedReportId}
                  setIsResizablePresent={setIsResizablePresent}
                />,
              ]}
            />
          ) : (
            <CustomProTable<BC07>
              columns={columns}
              handleResize={handleResize}
            />
          )}
          {/* </Spin> */}
          {/* =========== Table PO ===============*/}
        </Wrapper>
        <TemplateReportModal
          ref={templateReportModalRef}
          {...templateReportModalProps}
        />
      </div>
    );
  });
}
